import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

const Loader = () => {
  return (
    <>
      <div className="truman-ui-loader">
        <ClipLoader color={"#0b384e"} size={150} />
      </div>
    </>
  );
};

export default Loader;
